import { Instructor } from "@hubcapp/types";
import { useQuery } from "@apollo/react-hooks";

import InstructorInvoicesDataQuery from "../graph-ql/getInstructorInvoicesData.graphql";

const useInstructorInvoicesData = (id?: string) =>
  useQuery<{ instructor: Pick<Instructor, "id" | "invoices"> }>(
    InstructorInvoicesDataQuery,
    {
      variables: {
        id,
      },
      skip: !id,
    },
  );

export default useInstructorInvoicesData;
